// Copyright (c) 2022 by Move Closer

import { IRelatedService, ModuleContentResolver } from '../../contexts'
import { logger } from '../../support'

import { resolveArticle, resolveArticles } from '../resolvers'

import { ArticlesTeaserBoxModuleContent, ArticlesTeaserBoxModuleContentInput } from './ArticlesTeaserBox.contracts'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const resolveArticlesTeaserBoxModuleContent: ModuleContentResolver<ArticlesTeaserBoxModuleContentInput, ArticlesTeaserBoxModuleContent> =
  async (
    input: ArticlesTeaserBoxModuleContentInput,
    relatedService: IRelatedService
  ): Promise<ArticlesTeaserBoxModuleContent> => {
    try {
      const resolvedTabs = await Promise.all(input.tabs.map(async item => ({
        ...item,
        article: item.article
          ? await resolveArticle(item.article, relatedService)
          : item.articlesSet
            ? (await resolveArticles(item.articlesSet, relatedService))[0]
            : null
      })))

      return { ...input, tabs: resolvedTabs }
    } catch (e) {
      logger(e, 'warn')
      return { ...input, tabs: [] }
    }
  }
